import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
//import { production_credentials } from './production_credentials';
//import { development_credentials } from './development_credentials';
import { connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCzL8yYVpp4jMjYNICOU3CmaC8qBdBmMAs",
  authDomain: "review-ai-brain.firebaseapp.com",
  projectId: "review-ai-brain",
  storageBucket: "review-ai-brain.appspot.com",
  messagingSenderId: "297872038170",
  appId: "1:297872038170:web:0db73a44411167436574a3",
  measurementId: "G-409Y07BCRT"
};

//const credentials = process.env.NODE_ENV === 'development' ? 
//development_credentials
//: production_credentials;
//const credentials = production_credentials;
const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const cloudFunctions = firebase.functions();

//if(process.env.NODE_ENV === 'development')
//connectFunctionsEmulator(cloudFunctions, "localhost", 5001);

export { auth, db, cloudFunctions };